/**
 * LEGACY styled-components palettes, keyed by the study_configs COLOR_THEME
 * value. Kept verbatim (values AND lookup semantics, including the historical
 * "unknown key falls back to MENTALO" behavior) so existing deployments render
 * pixel-identically while the token-based theme system (src/theme/tokens.ts +
 * the Diapason THEME editor) takes over. Once every study carries a THEME
 * config, this file and the COLOR_THEME mechanism can be deleted.
 */

export interface LegacyPalette {
  primary: { main: string; background?: string; contrast: string };
  secondary: { main: string; background?: string; contrast: string };
  tertiary?: { main: string; background?: string; contrast: string };
  svg: { verified: string; finished: string };
}

export const LEGACY_PALETTES: Record<string, LegacyPalette> = {
  BLUE: {
    primary: {
      main: "#747474",
      background: "#b5fffc",
      contrast: "#041723",
    },
    secondary: {
      main: "#fecf48",
      contrast: "#041723",
    },
    svg: {
      verified: "verified-blue",
      finished: "finished-blue",
    },
  },
  GREEN: {
    primary: {
      main: "#0D8C9B",
      background: "#0D8C9B",
      contrast: "#fff",
    },
    secondary: {
      main: "#E76538",
      contrast: "#fff",
    },
    svg: {
      verified: "verified-green",
      finished: "finished-green",
    },
  },
  RED: {
    primary: {
      main: "#f2b994",
      background: "#f2b994",
      contrast: "#041723",
    },
    secondary: {
      main: "#041723",
      contrast: "#f2b994",
    },
    svg: {
      verified: "verified-red",
      finished: "finished-red",
    },
  },
  MENTALO: {
    primary: {
      main: "#4a4a4a", // Gris
      background: "#94F1EF", // Bleu clair
      contrast: "#041723", // Noir
    },
    secondary: {
      main: "#fecf48", // Jaune
      background: "#F1F0F0", // Gris clair
      contrast: "#041723", // Noir
    },
    svg: {
      verified: "verified-green",
      finished: "finished-green",
    },
  },
  TABAPSY: {
    primary: {
      main: "#4a4a4a", // Gris
      background: "#CDEBF3", // Bleu clair
      contrast: "#041723", // Noir
    },
    secondary: {
      main: "#F4A197", // Jaune
      background: "#F1F0F0", // Gris clair
      contrast: "#041723", // Noir
    },
    svg: {
      verified: "verified-green",
      finished: "finished-green",
    },
  },
  MENTALPLUS: {
    primary: {
      main: "#747474", // Gris
      background: "#CDEBF3", // Bleu clair
      contrast: "#041723", // Noir
    },
    secondary: {
      main: "#4285F4", // Bleu
      background: "#4285F4",
      contrast: "#ffffffff",
    },
    tertiary: {
      main: "#94F1EF",
      background: "#F1F0F0",
      contrast: "#041723",
    },
    svg: {
      verified: "verified-green",
      finished: "finished-green",
    },
  },
};
